import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatDate } from '@/utils/date';
import { fetchListByType } from '@/api/PMS/dic/dic';
import { insertHousePerson, fetchDetail, fetchCustomerList, findHousePerson } from '@/api/otherSystem/districtManagement/roomcustomer';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      outChecked: true,
      inChecked: false,
      loading: false,
      outDate: '',
      customerId: '',
      areaGroupId: '',
      customerList: [],
      userList: [],
      // 租户下拉
      userList2: [],
      // 家庭成员下拉
      yzName: '',
      yzList: [],
      // 业主集合（一般就一个）
      zkList: [],
      // 租客集合
      jtcyList: [],
      // 家庭成员集合
      houseTypeList: [],
      // 住户类型
      roomData: {},
      oldCustomerList: [],
      childData: {
        list: []
      }
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.outDate = formatDate(new Date(Date.now()), 'yyyy-MM-dd').toString();
      this.customerId = '';
      this.areaGroupId = '';
      this.outChecked = true;
      this.childData.list = [];
      this.customerList = [];
      this.roomData = {};
      this.yzList = []; // 业主集合（一般就一个）

      this.zkList = []; // 租客集合

      this.jtcyList = []; // 家庭成员集合

      this.loadHouseTypeOptions();

      if (this.keyValue > 0) {
        var queryData = {
          houseId: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          if (response.data.data !== null) {
            _this.roomData = response.data.data;
            _this.areaGroupId = response.data.data.areaGroupId;

            _this.remoteMethod();

            if (!response.data.data.customerName) {
              _this.outChecked = false;
            }
          } else {
            _this.outChecked = false;
          }
        });
      } else {
        this.roomData = {};
      }
    },
    // 获取住户列表
    loadHouseCustomerList: function loadHouseCustomerList(lvZhlx) {
      var _this2 = this;

      var queryData = {
        houseId: this.keyValue
      };
      findHousePerson(queryData).then(function (response) {
        if (response.data.data !== null) {
          if (response.data.data) {
            var customerList = response.data.data;
            _this2.yzList = customerList.yzList;
            _this2.jtcyList = customerList.jtcyList;
            _this2.zkList = customerList.zkList; // 业主

            var yzArr = _this2.customerList.filter(function (item) {
              return _this2.yzList[0] === item.customerId;
            });

            _this2.yzName = yzArr.length > 0 ? yzArr[0].customerName : ''; // 租户列表

            var selectedUserArr = _this2.customerList.filter(function (item) {
              return _this2.zkList.includes(item.customerId);
            });

            var noSelectUserArr = _this2.customerList.filter(function (item) {
              return !_this2.zkList.includes(item.customerId);
            });

            _this2.userList = selectedUserArr.concat(noSelectUserArr).slice(0, 20); // 家庭成员列表

            var selectedUserArr2 = _this2.customerList.filter(function (item) {
              return _this2.jtcyList.includes(item.customerId);
            });

            var noSelectUserArr2 = _this2.customerList.filter(function (item) {
              return !_this2.jtcyList.includes(item.customerId);
            });

            _this2.userList2 = selectedUserArr2.concat(noSelectUserArr2).slice(0, 20);
          }
        }
      });
    },
    remoteMethod: function remoteMethod() {
      var _this3 = this;

      var queryData = {
        areaGroupId: this.areaGroupId,
        customerName: ''
      };
      fetchCustomerList(queryData).then(function (r) {
        _this3.loading = false;
        _this3.customerList = r.data.data;

        _this3.loadHouseCustomerList();
      });
    },
    loadHouseTypeOptions: function loadHouseTypeOptions() {
      var _this4 = this;

      // 住户类型
      fetchListByType('lvzhlx').then(function (res) {
        _this4.houseTypeList = res.data.data;
      });
    },
    handUpdate: function handUpdate() {
      var _this5 = this;

      if (this.keyValue > 0) {
        var isPass = true; // 添加验证，如果出现选择了租户又选择家庭成员的情况则不允许提交

        if (this.zkList.length > 0 && this.jtcyList.length > 0) {
          this.zkList.forEach(function (item) {
            _this5.jtcyList.forEach(function (element) {
              if (item === element) {
                console.log('验证不通过');
                isPass = false;

                _this5.Alert({
                  alertType: 'valid',
                  message: '存在选择多个角色的用户，请检查！'
                });

                return;
              }
            });
          });
        }

        if (isPass) {
          var queryData = {
            jtcyList: this.jtcyList,
            zkList: this.zkList,
            houseId: this.keyValue
          };
          insertHousePerson(queryData).then(function (res) {
            if (res.data.code === 200) {
              _this5.$emit('handCancle', 'offCustomerList');

              _this5.Alert({
                alertType: 'update'
              });
            }
          });
        }
      }
    },
    userFilter: function userFilter() {
      var _this6 = this;

      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var arr = this.customerList.filter(function (item) {
        return item.customerName.includes(query) && !_this6.zkList.includes(item.customerId);
      });
      var selectedArr = this.customerList.filter(function (item) {
        return _this6.zkList.includes(item.customerId);
      });
      arr = selectedArr.concat(arr);

      if (arr.length > 20) {
        this.userList = arr.slice(0, 20);
      } else {
        this.userList = arr;
      }
    },
    userFilter2: function userFilter2() {
      var _this7 = this;

      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var arr = this.customerList.filter(function (item) {
        return item.customerName.includes(query) && !_this7.jtcyList.includes(item.customerId);
      });
      var selectedArr = this.customerList.filter(function (item) {
        return _this7.jtcyList.includes(item.customerId);
      });
      arr = selectedArr.concat(arr);

      if (arr.length > 20) {
        this.userList2 = arr.slice(0, 20);
      } else {
        this.userList2 = arr;
      }
    },
    handBindingCancle: function handBindingCancle() {
      this.$emit('handCancle', 'offCustomerList');
    }
  }
};